<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <!--<footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">GetBoarded</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span>
    </footer>-->
  <footer class="footer" id="footer" :style="footerStyles">
    <section class="container">
      <vs-row vs-w="12">
        <vs-col
          class="footer-brand mb-base"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="6"
          vs-xs="12"
        >
          <a href="/user/dashboard"
          ><img
            class="mb-base"
            src="@/assets/images/aboutUs/white gb Icon@4x.png"
            alt=""
          />
          </a>
          <p class="mb-base">
            Our mission is to empower the world is professionals to take control
            of their personal brand and become more successful.
          </p>
          <div class="social_links mb-8">
            <a
              class="social mr-5"
              href="https://www.facebook.com/Getboarded/"
              target="_blank"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_849_2893)">
                  <path
                    d="M24 12.001C23.9996 9.70787 23.3422 7.46281 22.1056 5.53165C20.8689 3.60049 19.1048 2.06411 17.0221 1.10439C14.9394 0.144672 12.6254 -0.198195 10.3538 0.116382C8.08235 0.430959 5.94854 1.3898 4.20505 2.87941C2.46156 4.36901 1.18139 6.32698 0.516104 8.52154C-0.149185 10.7161 -0.171736 13.0553 0.451122 15.2623C1.07398 17.4693 2.31616 19.4516 4.03061 20.9745C5.74506 22.4974 7.85999 23.4972 10.125 23.8555V15.4698H7.0785V12.001H10.125V9.3573C10.125 6.3498 11.9167 4.68855 14.6572 4.68855C15.5573 4.70103 16.4551 4.77924 17.3438 4.92255V7.87605H15.8302C15.5723 7.84179 15.31 7.86602 15.0628 7.94692C14.8155 8.02783 14.5896 8.16334 14.4018 8.34342C14.214 8.52349 14.0691 8.74352 13.978 8.98719C13.8868 9.23086 13.8516 9.49193 13.875 9.75105V12.001H17.2035L16.671 15.4698H13.875V23.8555C16.6978 23.409 19.2686 21.9696 21.1248 19.7964C22.9809 17.6233 24.0005 14.859 24 12.001Z"
                    fill="white"
                    fill-opacity="0.32"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_849_2893">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              class="social mr-5"
              href="https://twitter.com/gtbrdd?lang=en"
              target="_blank"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_849_2894)">
                  <path
                    d="M24 4.575C23.1 4.95 22.2001 5.25 21.15 5.325C22.2001 4.725 22.9501 3.75 23.3251 2.625C22.35 3.225 21.3 3.6 20.175 3.825C19.275 2.85 18 2.25 16.65 2.25C13.95 2.25 11.7 4.425 11.7 7.2C11.7 7.575 11.775 7.95 11.85 8.325C7.72505 8.1 4.12505 6.15 1.65005 3.15C1.20005 3.9 0.975049 4.725 0.975049 5.625C0.975049 7.35 1.87505 8.85 3.15005 9.75C2.32505 9.75 1.57505 9.525 0.900049 9.15V9.225C0.900049 11.625 2.62505 13.575 4.87505 14.025C4.42505 14.1 4.05005 14.175 3.60005 14.175C3.30005 14.175 3.00005 14.175 2.70005 14.1C3.30005 16.05 5.17505 17.475 7.27505 17.55C5.62505 18.9 3.45005 19.65 1.12505 19.65C0.750049 19.65 0.300049 19.65 -0.0749512 19.575C2.17505 20.925 4.80005 21.75 7.57505 21.75C16.65 21.75 21.6 14.25 21.6 7.725C21.6 7.5 21.6 7.275 21.6 7.125C22.5 6.375 23.325 5.55 24 4.575Z"
                    fill="white"
                    fill-opacity="0.32"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_849_2894">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              class="social mr-5"
              href="https://www.instagram.com/getboarded/?hl=en"
              target="_blank"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.775C15 2.775 15.36 2.78625 16.5458 2.84025C17.2593 2.84867 17.9662 2.97984 18.6353 3.228C19.1237 3.40832 19.5656 3.69588 19.9283 4.0695C20.3019 4.43218 20.5894 4.87402 20.7698 5.3625C21.0179 6.0316 21.1491 6.73841 21.1575 7.452C21.2115 8.64 21.225 9 21.225 12C21.225 15 21.2138 15.36 21.1598 16.5458C21.1513 17.2593 21.0202 17.9662 20.772 18.6353C20.5847 19.1202 20.2981 19.5606 19.9305 19.9282C19.5629 20.2958 19.1225 20.5825 18.6375 20.7698C17.9684 21.0179 17.2616 21.1491 16.548 21.1575C15.3623 21.2115 15.006 21.2228 12.0023 21.2228C8.9985 21.2228 8.64225 21.2115 7.4565 21.1575C6.74291 21.1491 6.0361 21.0179 5.367 20.7698C4.87852 20.5894 4.43668 20.3019 4.074 19.9282C3.70038 19.5656 3.41282 19.1237 3.2325 18.6353C2.98434 17.9662 2.85317 17.2593 2.84475 16.5458C2.7885 15.36 2.775 15.0037 2.775 12C2.775 8.99625 2.78625 8.64 2.84025 7.45425C2.84867 6.74066 2.97984 6.03385 3.228 5.36475C3.40898 4.87606 3.69731 4.4342 4.07175 4.07175C4.43443 3.69813 4.87627 3.41057 5.36475 3.23025C6.03385 2.98209 6.74066 2.85092 7.45425 2.8425C8.64 2.7885 9 2.775 12 2.775ZM12 0.75C8.9445 0.75 8.56125 0.76275 7.362 0.8175C6.42842 0.83728 5.5049 1.01478 4.6305 1.3425C3.88032 1.62483 3.20059 2.06707 2.6385 2.6385C2.06626 3.20037 1.62324 3.88012 1.34025 4.6305C1.01253 5.5049 0.83503 6.42842 0.81525 7.362C0.76275 8.56125 0.75 8.9445 0.75 12C0.75 15.0555 0.76275 15.4388 0.8175 16.638C0.83728 17.5716 1.01478 18.4951 1.3425 19.3695C1.62549 20.1199 2.06851 20.7996 2.64075 21.3615C3.20262 21.9337 3.88237 22.3768 4.63275 22.6597C5.50715 22.9875 6.43067 23.165 7.36425 23.1847C8.56425 23.2395 8.94675 23.2523 12.0023 23.2523C15.0578 23.2523 15.441 23.2395 16.6403 23.1847C17.5738 23.165 18.4974 22.9875 19.3718 22.6597C20.1188 22.3702 20.7972 21.928 21.3638 21.3615C21.9303 20.795 22.3724 20.1165 22.662 19.3695C22.9897 18.4951 23.1672 17.5716 23.187 16.638C23.2418 15.438 23.2545 15.0555 23.2545 12C23.2545 8.9445 23.2418 8.56125 23.187 7.362C23.1672 6.42842 22.9897 5.5049 22.662 4.6305C22.379 3.88012 21.936 3.20037 21.3638 2.6385C20.8019 2.06626 20.1221 1.62324 19.3718 1.34025C18.4974 1.01253 17.5738 0.83503 16.6403 0.81525C15.4388 0.76275 15.0555 0.75 12 0.75Z"
                  fill="white"
                  fill-opacity="0.32"
                />
                <path
                  d="M12 6.22461C10.8578 6.22461 9.74125 6.56331 8.79156 7.19787C7.84187 7.83244 7.10167 8.73437 6.66457 9.78961C6.22748 10.8449 6.11311 12.006 6.33594 13.1263C6.55877 14.2465 7.10879 15.2755 7.91644 16.0832C8.72408 16.8908 9.75309 17.4408 10.8733 17.6636C11.9936 17.8865 13.1547 17.7721 14.21 17.335C15.2652 16.8979 16.1671 16.1577 16.8017 15.208C17.4363 14.2583 17.775 13.1418 17.775 11.9996C17.775 10.468 17.1665 8.99909 16.0835 7.91607C15.0005 6.83305 13.5316 6.22461 12 6.22461ZM12 15.7496C11.2583 15.7496 10.5333 15.5297 9.91659 15.1176C9.29991 14.7056 8.81926 14.1199 8.53543 13.4347C8.2516 12.7495 8.17734 11.9955 8.32203 11.268C8.46673 10.5406 8.82388 9.87241 9.34833 9.34796C9.87277 8.82351 10.541 8.46636 11.2684 8.32166C11.9958 8.17697 12.7498 8.25123 13.435 8.53506C14.1203 8.81889 14.7059 9.29954 15.118 9.91622C15.53 10.5329 15.75 11.2579 15.75 11.9996C15.75 12.9942 15.3549 13.948 14.6516 14.6513C13.9484 15.3545 12.9945 15.7496 12 15.7496Z"
                  fill="white"
                  fill-opacity="0.32"
                />
                <path
                  d="M18.0053 7.34453C18.7509 7.34453 19.3553 6.74012 19.3553 5.99453C19.3553 5.24895 18.7509 4.64453 18.0053 4.64453C17.2597 4.64453 16.6553 5.24895 16.6553 5.99453C16.6553 6.74012 17.2597 7.34453 18.0053 7.34453Z"
                  fill="white"
                  fill-opacity="0.32"
                />
              </svg>
            </a>

            <a class="social mr-5" href="#" target="_blank"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 0.299805C5.4 0.299805 0 5.6998 0 12.2998C0 17.6248 3.45 22.1248 8.175 23.6998C8.775 23.7748 9 23.4748 9 23.0998C9 22.7998 9 22.0498 9 21.0748C5.625 21.8248 4.95 19.4998 4.95 19.4998C4.425 18.1498 3.6 17.7748 3.6 17.7748C2.475 17.0248 3.675 17.0248 3.675 17.0248C4.875 17.0998 5.55 18.2248 5.55 18.2248C6.6 20.0248 8.325 19.4998 9.075 19.1998C9.15 18.4498 9.525 17.9248 9.825 17.6248C7.125 17.3248 4.35 16.2748 4.35 11.6998C4.35 10.4248 4.8 9.29981 5.55 8.47481C5.4 8.17481 5.025 6.9748 5.7 5.3248C5.7 5.3248 6.675 5.02481 9 6.52481C9.975 6.22481 10.95 6.14981 12 6.14981C13.05 6.14981 14.025 6.29981 15 6.52481C17.325 4.94981 18.3 5.2498 18.3 5.2498C18.975 6.89981 18.525 8.09981 18.45 8.39981C19.2 9.22481 19.65 10.2748 19.65 11.6248C19.65 16.1998 16.875 17.2498 14.175 17.5498C14.625 17.9248 15 18.6748 15 19.7998C15 21.3748 15 22.7248 15 23.0998C15 23.3998 15.225 23.7748 15.825 23.6998C20.55 22.1248 24 17.6248 24 12.2998C24 5.6998 18.6 0.299805 12 0.299805Z"
                  fill="white"
                  fill-opacity="0.32"
                />
              </svg>
            </a>
          </div>
        </vs-col>

        <!--<vs-col
          v-if="alexPage && organizationSlug==='dpd-belux' "
          class="footer-col"
          :class="{ 'alex-footer': alexPage }"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <h5 class="mb-base">How it Works</h5>
          <ul>
            <li class="mb-3 cursor-pointer">
              <a @click="$router.push(`/${organizationSlug}/alex/home`)">ALEX</a>
            </li>
            <li class="mb-3 alex-link-item">
              <a @click="$router.push(`/${organizationSlug}/alex/connect`)">Connect</a>
            </li>
            <li class="mb-3 alex-link-item">
              <a @click="$router.push(`/${organizationSlug}/alex/curate`)">Curate</a>
            </li>
            <li class="mb-3 alex-link-item">
              <a @click="$router.push(`/${organizationSlug}/alex/customize`)">Customize</a>
            </li>
          </ul>
        </vs-col> -->
        <vs-col
          class="footer-col mb-base"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="6"
          vs-xs="12"
        >
          <h5 class="mb-base">Company</h5>
          <ul>
            <li class="mb-3"><a href="/user/dashboard">Home</a></li>
            <li class="mb-3"><a href="/about-us">About</a></li>
            <li class="mb-3"><a href="/contact-us">Contact</a></li>
            <li class="mb-3"><a href="/integrations">Integrations</a></li>
          </ul>
        </vs-col>
        <vs-col
          class="footer-col mb-base"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <h5 class="mb-base">Partners</h5>
          <ul>
            <li class="mb-3"><a href="/company">Companies</a></li>
            <li class="mb-3"><a href="/university">Universities</a></li>
            <!-- <li class="mb-3"><a href="#">Recruiters</a></li> -->
            <!-- <li class="mb-3"><a href="#">Events</a></li> -->
          </ul>
        </vs-col>
        <vs-col
          class="footer-col mb-base"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="12"
        >
          <h5 class="mb-base">Legal</h5>
          <ul>
            <li class="mb-3"><a href="/privacy-policy">Privacy</a></li>
            <li class="mb-3"><a href="/terms-of-use">Terms</a></li>
          </ul>
        </vs-col>
        <vs-col
          class="footer-col"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="3"
          vs-xs="8"
        >
          <h5 class="mb-base">Contact</h5>
          <ul>
            <li class="mb-3">
              <vs-icon
                icon="icon-phone"
                icon-pack="feather"
                class="mr-3"
              ></vs-icon
              ><a href="#">+351 912159105</a>
            </li>
            <li class="mb-3">
              <vs-icon
                icon="icon-map-pin"
                icon-pack="feather"
                class="mr-3"
              ></vs-icon
              ><a href="#"
                >GetBoarded Technologies, PCI · Creative Science Park, Aveiro
                Region, 3830-352 Ílhavo, Portugal<br />
                NIF/NIPC - 515992640</a
              >
            </li>
          </ul>
        </vs-col>
        <hr class="divider" />
      </vs-row>
      <vs-row class="footer-bottom" vs-w="12">
        <vs-col
          class="footer-social"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-xs="12"
        >
        </vs-col>
        <vs-col
          class="footer-copyright"
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          © {{ new Date().getFullYear() }} GetBoarded, Inc. All rights reserved
        </vs-col>
      </vs-row>
    </section>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    bgColor: {
      type: String,
      default: "#16141c"
    },
    borderTop: {
      type: String,
      default: "0rem solid white"
    }
  },
  data() {
    return {
      input2: "",
      // pageFooterBackgroundColor: this.$store.state.pageFooterBackgroundColor
    };
  },
  computed: {
    footerStyles() {
      return {
        "background-color": this.bgColor,
        "border-top": this.borderTop
      };
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    pageType() {
      return this.$store.state.pageType;
    },
    pageFooterBackgroundColor() {
      return this.$store.state.pageFooterBackgroundColor;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    },
  },
};
</script>

<style scoped>
svg:hover path {
  fill: #F29300;
  fill-opacity: 1;
  transition: all ease 0.3s;
}
.social_links {
  display: flex;
}
.social_links >>> img:hover {
  background-color: aliceblue;
  transition: all ease 0.3s;
}
.divider {
  opacity: 0.12;
  width: inherit;
  margin-top: 25px;
}
.newsletter-card h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 28px;
  text-align: left;
  color: #231d4f;
}
.newsletter-card p {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 28px;
  /* identical to box height, or 140% */

  text-align: left;
  letter-spacing: -0.01em;

  color: #848199;
}
.newsletter-input-group >>> input {
  border-radius: 100px 0 0 100px;
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}
.newsletter-input-group >>> i {
  color: #848199 !important;
}
button {
  border-radius: 0 100px 100px 0;
}
/*===============================================*/
/*  8. FOOTER 	 						 */
/*===============================================*/
/* BLOCK - footer */
.footer {
  position: relative;
  padding: 4rem 2rem 2rem 2rem;
  border-top: 7rem solid white;
}
.footer-brand h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 115%;
  letter-spacing: -0.04em;
  color: #ffffff;
}
.footer-brand p {
  width: 80%;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 180%;
  color: rgba(255, 255, 255, 0.56);
}
.footer-col h5 {
  font-style: normal;
  font-weight: bold;
  /*font-size: 16px;*/
  line-height: 15px;
  color: #ffffff;
}
.footer-bottom {
  margin-top: 4rem;
}
.footer-col ul li a {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 180%;
  color: #ffffff;
}
.footer-copyright {
  font-weight: normal;
  font-size: 16px;
  line-height: 180%;
  text-align: center;
  color: rgba(255, 255, 255, 0.56);
}

/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  section {
    padding: 5rem 1rem;
    /*background: #FFFFFF;*/
  }
  .newsletter-card h3 {
    line-height: 28px;
  }
  .footer {
    padding: 4rem 1rem 5rem 1rem;
  }
}
</style>
